import { ref } from "vue";
import type { AlgorithmType } from "../../redistribution/models/AlgorithmType.ts";
import type { DemandSourceType } from "../../redistribution/models/DemandSourceType.ts";
import { DEMAND_SOURCE_OPTIONS } from "../../redistribution/models/DemandSourceType.ts";

export function createSearchFiltersModule() {
  const division = ref<string | undefined>(undefined);
  const warehouseIds = ref<string[]>([]);
  const vendorId = ref<string | undefined>(undefined);
  const color = ref<string | undefined>(undefined);
  const collection = ref<string | undefined>(undefined);
  const rateOfSale = ref<string | undefined>("30");
  const poCube = ref<string>("2300");
  const algorithmType = ref<AlgorithmType>("Milp");
  const demandSource = ref<DemandSourceType>("InventoryFlow");
  const availableDemandSources = ref<DemandSourceType[]>(
    DEMAND_SOURCE_OPTIONS.map((option) => option.value)
  );
  const activeSearchTab = ref<string>("Vendor Search");
  const selectedTestFile = ref<string>("");
  const arrivalDateFrom = ref<Date | undefined>(new Date());
  const searching = ref(false);

  const createDefaultShipDateTo = (): Date => {
    const date = new Date();
    date.setDate(date.getDate() + 14);
    return date;
  };

  const arrivalDateTo = ref<Date | undefined>(createDefaultShipDateTo());

  function setVendorId(strVendorId: string | undefined): void {
    vendorId.value = strVendorId;
  }

  function setWarehouseIds(nextWarehouseIds: string[]): void {
    warehouseIds.value = nextWarehouseIds;
  }

  function clearSearchParameters(): void {
    division.value = undefined;
    warehouseIds.value = [];
    vendorId.value = undefined;
    color.value = undefined;
    collection.value = undefined;
    arrivalDateFrom.value = new Date();
    arrivalDateTo.value = createDefaultShipDateTo();
  }

  function setAvailableDemandSources(sources: DemandSourceType[]): void {
    availableDemandSources.value =
      sources.length > 0 ? sources : DEMAND_SOURCE_OPTIONS.map((o) => o.value);
    if (!availableDemandSources.value.includes(demandSource.value)) {
      demandSource.value = availableDemandSources.value[0] ?? "InventoryFlow";
    }
  }

  return {
    division,
    warehouseIds,
    vendorId,
    color,
    collection,
    rateOfSale,
    poCube,
    algorithmType,
    demandSource,
    availableDemandSources,
    setAvailableDemandSources,
    activeSearchTab,
    selectedTestFile,
    arrivalDateFrom,
    arrivalDateTo,
    searching,
    setVendorId,
    setWarehouseIds,
    clearSearchParameters,
  };
}
